import { render, staticRenderFns } from "./user-popover.vue?vue&type=template&id=6fd073f6&scoped=true"
import script from "./user-popover.vue?vue&type=script&lang=js"
export * from "./user-popover.vue?vue&type=script&lang=js"
import style0 from "./user-popover.vue?vue&type=style&index=0&id=6fd073f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd073f6",
  null
  
)

export default component.exports